@if (isSpinnerVisible) {
  <div id="http-loader">
    <div class="loader-bg">
      <!--sk-cube-grid-->
      @if (spinner() === Spinkit.skCubeGrid) {
        <div class="sk-cube-grid colored-parent">
          <div class="sk-cube sk-cube1"></div>
          <div class="sk-cube sk-cube2"></div>
          <div class="sk-cube sk-cube3"></div>
          <div class="sk-cube sk-cube4"></div>
          <div class="sk-cube sk-cube5"></div>
          <div class="sk-cube sk-cube6"></div>
          <div class="sk-cube sk-cube7"></div>
          <div class="sk-cube sk-cube8"></div>
          <div class="sk-cube sk-cube9"></div>
        </div>
      }
      <!--sk-rotating-plane-->
      @if (spinner() === Spinkit.skRotatingPlane) {
        <div class="sk-rotating-plane colored-parent"></div>
      }
      <!--sk-double-bounce-->
      @if (spinner() === Spinkit.skDoubleBounce) {
        <div class="sk-double-bounce colored-parent">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      }
      <!--sk-wave-->
      @if (spinner() === Spinkit.skWave) {
        <div class="sk-wave colored-parent">
          <div class="sk-rect sk-rect1"></div>
          <div class="sk-rect sk-rect2"></div>
          <div class="sk-rect sk-rect3"></div>
          <div class="sk-rect sk-rect4"></div>
          <div class="sk-rect sk-rect5"></div>
        </div>
      }
      <!--sk-wandering-cubes-->
      @if (spinner() === Spinkit.skWanderingCubes) {
        <div class="sk-wandering-cubes colored-parent">
          <div class="sk-cube sk-cube1"></div>
          <div class="sk-cube sk-cube2"></div>
        </div>
      }
      <!--sk-spinner-pulse-->
      @if (spinner() === Spinkit.skSpinnerPulse) {
        <div class="sk-spinner sk-spinner-pulse colored-parent"></div>
      }
      <!--sk-chasing-dots-->
      @if (spinner() === Spinkit.skChasingDots) {
        <div class="sk-chasing-dots colored-parent">
          <div class="sk-child sk-dot1"></div>
          <div class="sk-child sk-dot2"></div>
        </div>
      }
      <!--sk-three-bounce-->
      @if (spinner() === Spinkit.skThreeBounce) {
        <div class="sk-three-bounce colored-parent">
          <div class="sk-child sk-bounce1"></div>
          <div class="sk-child sk-bounce2"></div>
          <div class="sk-child sk-bounce3"></div>
        </div>
      }
      <!-- material-line -->
      @if (spinner() === Spinkit.skLine) {
        <div class="sk-line-material colored-parent">
          <div class="sk-child sk-bounce1" [style.backgroundColor]="backgroundColor()"></div>
        </div>
      }
    </div>
  </div>
}